import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const LOGIN_PATH = "/login";
console.log("→ API_BASE_URL is:", API_BASE_URL);

const api = axios.create({
    baseURL: API_BASE_URL
});

api.interceptors.request.use(
    (config) => {
        const requestUrl = String(config?.url || "");
        const isImpersonationTokenRequest = requestUrl.includes("session/generate-token/");

        // Check for token in URL query parameter first (prioritize over localStorage)
        const urlParams = new URLSearchParams(window.location.search);
        const tokenFromUrl = urlParams.get('token');

        // For "generate-token" we must always use admin's stored session token.
        // Otherwise a URL token (possibly another user) can trigger 403 Permission denied.
        const localToken = localStorage.getItem("sessionID");
        const token = isImpersonationTokenRequest
            ? localToken
            : (tokenFromUrl || localToken);
        
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            // Also add token to query if it's from URL (for backend middleware)
            if (tokenFromUrl && !isImpersonationTokenRequest) {
                config.params = config.params || {};
                config.params.token = tokenFromUrl;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);


api.interceptors.response.use(
    (response) => response,
    (error) => {
        const requestUrl = String(error?.config?.url || "");
        const isImpersonationTokenRequest = requestUrl.includes("session/generate-token/");

        if (error.response?.status === 401) {
            localStorage.removeItem("sessionID");
            const base = window.location.origin + (process.env.PUBLIC_URL || "");
            window.location.href = `${base}${LOGIN_PATH}`;
        }

        if (error.response?.status === 403) {
            // "Login as user" can legitimately return 403 (not SUPER_ADMIN).
            // Do not force logout in this case; let caller handle gracefully.
            if (isImpersonationTokenRequest) {
                return Promise.reject(error);
            }
            localStorage.removeItem("sessionID");
            const base = window.location.origin + (process.env.PUBLIC_URL || "");
            window.location.href = `${base}${LOGIN_PATH}`;
        }

        if (error.response?.status === 422) {
            const errors = error.response.data.errors;
            return Promise.reject({ errors });
        }

        return Promise.reject(error);
    }
);

export default api;